import { forwardRef, type TextareaHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid = false, ...props }, ref) => (
    <textarea
      aria-invalid={invalid || undefined}
      className={twMerge(
        "min-h-28 w-full resize-y rounded-lg border border-line bg-surface px-3.5 py-3 text-body shadow-sm transition-[border-color,box-shadow] placeholder:text-muted/75 hover:border-accent/60 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20 disabled:cursor-not-allowed disabled:bg-line/30 disabled:opacity-70",
        invalid && "border-danger",
        className
      )}
      ref={ref}
      {...props}
    />
  )
);
Textarea.displayName = "Textarea";
